var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 23.6666C18.8825 23.6666 24.1668 18.3849 24.1668 12.0057C24.1668 5.63789 18.8711 0.344727 12.4887 0.344727C6.11781 0.344727 0.833496 5.63789 0.833496 12.0057C0.833496 18.3849 6.12924 23.6666 12.5002 23.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4889 15.7664C12.2716 15.7664 12.0657 15.675 11.8941 15.492L7.91375 11.4221C7.76506 11.262 7.67355 11.022 7.67355 10.839C7.67355 10.3817 7.98239 10.0617 8.42847 10.0617C8.6801 10.0617 8.8631 10.1302 9.01179 10.2903L9.67519 11.022L11.8255 13.4342L11.6883 11.2735V5.86598C11.6883 5.40869 12.0085 5.07715 12.4889 5.07715C12.935 5.07715 13.2781 5.40869 13.2781 5.86598V11.2735L13.1523 13.4227L15.2683 11.0334L15.989 10.2903C16.1491 10.1302 16.355 10.0617 16.5837 10.0617C17.0184 10.0617 17.3271 10.4046 17.3271 10.839C17.3271 11.0563 17.2585 11.2392 17.0755 11.4335L13.0837 15.492C12.9236 15.6635 12.7062 15.7664 12.4889 15.7664ZM8.07388 18.2472C7.61638 18.2472 7.28467 17.9156 7.28467 17.4469C7.28467 17.0011 7.61638 16.6581 8.07388 16.6581H16.9383C17.3957 16.6581 17.7161 17.0011 17.7161 17.4469C17.7161 17.9156 17.3957 18.2472 16.9383 18.2472H8.07388Z",
    fill: "#FF774D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6be465c499c85bc15282ff91eb6b934b.svg";
export { ForwardRef as ReactComponent };